import React from "react";
import { Link } from "react-router-dom";
import { TaskList } from "../../assets/svg/AllSvg";
import CustomTable from "../../commons/CustomTable";
import AllGood from "../../commons/AllGood";

const OnGoingTask = ({ serviceRequestData, loading }) => {
  const ColumnHeaders = () => {
    return (
      <>
        <th
          scope="col"
          className="px-5 py-3 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades whitespace-nowrap "
        >
          No.
        </th>
        <th
          scope="col"
          className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
        >
          Task
        </th>
        <th
          scope="col"
          className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
        >
          Due Date
        </th>
        <th
          scope="col"
          className="px-5 py-2 border-b table_responsive_text font-semibold text-left bg-secondary_light_shades"
        >
          Actions
        </th>
      </>
    );
  };

  const DataRows = () => {
    return (
      <>
        {(serviceRequestData?.data || [])?.map(
          (element, index) =>
            index < 3 && (
              <tr
                className={
                  "border-b table_responsive_text bg-light_secondary hover:bg-secondary_light_shades"
                }
                key={element?.id}
              >
                <td className="px-5 py-3 truncate">{index + 1}</td>
                <td className="px-5 py-3 truncate max-w-52">
                  {element?.service?.service_name}
                </td>
                <td className="px-5 py-3 truncate">
                  {element?.service?.durations}
                </td>
                <td className="px-5 py-3 truncate">
                  <Link
                    to={"/service-request-details"}
                    state={element}
                    className="text-theme border-b border-theme"
                  >
                    View
                  </Link>
                </td>
              </tr>
            )
        )}
      </>
    );
  };
  return (
    <>
      <p className="lg:text-lg flex items-center font-ebGaramond font-semibold mb-2">
        <TaskList className="fill-theme mr-2" width={24} /> On-Going Task
      </p>
      {serviceRequestData?.data?.length > 0 ? (
        <CustomTable
          columnHeaders={<ColumnHeaders />}
          dataRows={<DataRows />}
          data={serviceRequestData}
          overflowVisibleLg={false}
          // loader
          loading={loading}
          showPagination={false}
        />
      ) : (
        <AllGood />
      )}
      <div className="text-right mt-3">
        <Link
          to={"/on-going"}
          className="text-theme border-b border-theme sm:text-sm text-xs font-bold uppercase text-right w-full"
        >
          View All
        </Link>
      </div>
    </>
  );
};

export default OnGoingTask;
